import { render, staticRenderFns } from "./footerPage.vue?vue&type=template&id=a37248f8&scoped=true"
import script from "./footerPage.vue?vue&type=script&lang=js"
export * from "./footerPage.vue?vue&type=script&lang=js"
import style0 from "./footerPage.vue?vue&type=style&index=0&id=a37248f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37248f8",
  null
  
)

export default component.exports